var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6112 7.4519C17.8193 8.6788 17.8595 10.6426 16.732 11.9186L16.6112 12.0481L13.3157 15.1995C13.0033 15.5168 12.4967 15.5168 12.1843 15.1995C11.8959 14.9066 11.8737 14.4458 12.1178 14.127L12.1843 14.0505L15.4799 10.899C16.0718 10.2978 16.103 9.34277 15.5733 8.70431L15.4799 8.60095L12.1843 5.44952C11.8719 5.13222 11.8719 4.61778 12.1843 4.30048C12.4727 4.00758 12.9265 3.98505 13.2403 4.23288L13.3157 4.30048L16.6112 7.4519Z",
    fill: "#032282"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8112 7.4519C13.0193 8.6788 13.0595 10.6426 11.932 11.9186L11.8112 12.0481L8.51569 15.1995C8.20327 15.5168 7.69674 15.5168 7.38432 15.1995C7.09594 14.9066 7.07375 14.4458 7.31777 14.127L7.38432 14.0505L10.6799 10.899C11.2718 10.2978 11.303 9.34277 10.7733 8.70431L10.6799 8.60095L7.38432 5.44952C7.0719 5.13222 7.0719 4.61778 7.38432 4.30048C7.67271 4.00758 8.1265 3.98505 8.44033 4.23288L8.51569 4.30048L11.8112 7.4519Z",
    fill: "#032282"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.30da93c9b73c5bd0ea2f2694ab725c22.svg";
export { ForwardRef as ReactComponent };